import { renderPage } from "renderPage"
import { ClubForumIndexPage } from "./Page"

renderPage({ component: ClubForumIndexPage })
